<template>
  <div class="spelling-row"
       @click="organizerDetail">
    <div class="user">
      <div class="user-face"
           :style="{backgroundImage: `url(${organizer.avatar_url})`}"></div>
      <div class="user-text">
        <div class="name">{{organizer.user_nick}}</div>
        <div class="surplus">还差{{organizer.group_num-organizer.follower_count}}人成团<span class="time">剩余{{ timeText }}</span></div>
      </div>
    </div>
    <div class="go-btn">去参团</div>
  </div>
</template>
<script>
export default {
  props: ['organizer'],
  data() {
    return {
      timeText: '00:00:00',
      setTimeoutId: null
    }
  },
  created() {
    if (!this.organizer || !this.organizer.id) {
      return
    }
    let ms = Date.newDate(this.organizer.end_time).getTime() - new Date().getTime()
    this.countdown(ms)
  },
  methods: {
    countdown(msec) {
      // 相差的毫秒数
      if (msec <= 0) {
        return window.clearTimeout(this.setTimeoutId)
      }
      this.timeText = Date.formatMs(msec, (msec / (24 * 60 * 60 * 1000)) > 1 ? 'DD天 hh:mm:ss' : 'hh:mm:ss')
      // 一秒后递归
      this.setTimeoutId = setTimeout(() => {
        this.countdown(msec - 1000)
      }, 1000)
    },
    organizerDetail() {
      window.location.href = `//${window.location.host}/center/groupView?orgId=${this.organizer.id}`
    }
  },

  beforeDestory() {
    window.clearTimeout(this.setTimeoutId)
  },
}
</script>
<style lang="less">
@import (reference) url("../../common.less");
.spelling-row {
  .cells;
  align-items: center;
  padding: 1.25rem 0;
  .user {
    flex: 1;
    .cells;
    .user-face {
      .image-cover;
      width: 2.47rem;
      height: 2.47rem;
      border-radius: 50%;
      background-color: tomato;
    }
    .user-text {
      flex: 1;
      padding-left: 0.35rem;
      .name {
        font: 0.88rem/1.24rem @fontStack;
        color: @text1;
      }
      .surplus {
        padding-top: 0.35rem;
        font: 0.65rem/0.88rem @fontStack;
        color: @text3;
        span.time {
          padding-left: 0.88rem;
        }
      }
    }
  }
  .go-btn {
    width: 3.65rem;
    color: @groupCommonColor;
    font-size: .82rem;
    text-align: center;
    line-height: 1.76rem;
    border: .03rem solid @groupCommonColor;
    border-radius: 2.94rem;
  }
  .vux-1px-b;
  &:after {
    border-color: #e6e6e6;
  }
  &:last-child {
    &:after {
      border-bottom: none;
    }
  }
}
</style>
